import StringHelper from './string'
import writeXlsxFile from 'write-excel-file'

export default {
  getOnlyIsSelectedProductAndLot(data) {
    let tempData = []
    for (let i = 0; i < data.length; i++) {
      if (data[i].batches.length > 0) {
        let tempBatches = []
        for (let j = 0; j < data[i].batches.length; j++) {
          if (data[i].batches[j].isSelected) {
            tempBatches.push(data[i].batches[j])
          }
        }
        if (tempBatches.length > 0) {
          let tempObj = data[i]
          tempObj.batches = tempBatches
          tempData.push(tempObj)
        }
      }
    }
    return tempData
  },
  
  getTransferExportRows(payload){
    let rows = []
    for(let i = 0; i < payload.length; i++){
      let product = payload[i]
      console.log('product', product)
      if(product.transferBatches?.length > 0){
        for(let j = 0; j < product.transferBatches.length; j++){
          if(product.transferBatches[j].isSelected){
            let batch = product.transferBatches[j]
            rows.push({
                name: product?.productDetails?.name || '',
                category: product?.categoryName || '',
                sku: product?.productDetails?.sku || '',
                variant: product.variantName || '',
                lot: batch.batchName || '',
                qtySource: batch.actualBatch?.current_nou != null ? batch.actualBatch.current_nou : '',
                qtyDest: batch?.toBatch?.current_nou != null ? batch.toBatch.current_nou : 0,
                transferQty: batch?.actualTransferQty
            })
          }
        }
      } else{
        if(product.isSelected){
          rows.push({
            name: product?.productDetails?.name || '',
            category: product?.categoryName || '',
            sku: product?.productDetails?.sku || '',
            variant: product.variantName || '',
            lot: '',
            qtySource: product.actualProductStock?.activeStock != null ? product.actualProductStock.activeStock : 0,
            qtyDest: product.toProductStock?.activeStock != null ? product.toProductStock.activeStock : 0,
            transferQty: product?.transferQty
          })
        }
      }

      for(let v = 0; v < (product.transferVariants || []).length; v++){
        let variant = product.transferVariants[v]
        if(variant.transferBatches?.length > 0){
          for(let b = 0; b < variant.transferBatches.length; b++){
            if(variant.transferBatches[b].isSelected){
              let batch = variant.transferBatches[b]
              rows.push({
                  name: product?.productDetails?.name || '',
                  category: product?.categoryName || '',
                  sku: product?.productDetails?.sku || '',
                  variant: variant.variantName || '',
                  lot: batch.batchName || '',
                  qtySource: batch.actualBatch?.current_nou != null ? batch.actualBatch.current_nou : '',
                  qtyDest: batch?.toBatch?.current_nou != null ? batch.toBatch.current_nou : 0,
                  transferQty: batch?.actualTransferQty
              })
            }
          }
        } else {
          if(variant.isSelected){
            rows.push({
              name: product?.productDetails?.name || '',
              category: product?.categoryName || '',
              sku: product?.productDetails?.sku || '',
              variant: variant.variantName || '',
              lot: '',
              qtySource: variant.actualProductStock?.activeStock != null ? variant.actualProductStock.activeStock : 0,
              qtyDest: variant.toProductStock?.activeStock != null ? variant.toProductStock.activeStock : 0,
              transferQty: variant?.transferQty
            })
          }
        }
      }
    }
    return rows
  },

  async exportTransfer(fileName, data){
    let schema = [
      {
        column: 'Name',
        type: String,
        wrap: true,
        alignVertical: 'center',
        align: 'center',
        value: i => i.name || ''
      },
      {
        column: 'Category',
        type: String,
        wrap: true,
        alignVertical: 'center',
        align: 'center',
        value: i => i.category || ''
      },
      {
        column: 'Sku',
        type: String,
        wrap: true,
        alignVertical: 'center',
        align: 'center',
        value: i => i.sku || ''
      },
      {
        column: 'Variant',
        type: String,
        wrap: true,
        alignVertical: 'center',
        align: 'center',
        value: i => i.variant || ''
      },
      {
        column: 'Lot #',
        type: String,
        wrap: true,
        alignVertical: 'center',
        align: 'center',
        value: i => i.lot || ''
      },
      {
        column: 'Qty at Source',
        type: Number,
        wrap: true,
        alignVertical: 'center',
        align: 'center',
        value: i => i.qtySource !== '' && i.qtySource != null ? i.qtySource : ''
      },
      {
        column: 'Qty at Dst.',
        type: Number,
        wrap: true,
        alignVertical: 'center',
        align: 'center',
        value: i => i.qtyDest !== '' && i.qtyDest != null ? i.qtyDest : ''
      },
      {
        column: 'Transfer Qty',
        type: Number,
        wrap: true,
        alignVertical: 'center',
        align: 'center',
        value: i => i.transferQty !== '' && i.transferQty != null ? i.transferQty : ''
      }
    ]

    let xlBlob = await writeXlsxFile(data, {
      schema: schema,
    });
    let url = URL.createObjectURL(xlBlob);
    let link = document.createElement("a");
    link.setAttribute('href', url);
    link.setAttribute('download', fileName);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
